export const DECIMAL_NUMBER_INPUT_REGEX = /[\d.-]/;
// A non-negative decimal money string: one or more digits, an optional single
// decimal part. Rejects empty, negatives, and any non-numeric input. Used as the
// validation backstop for money fields kept as STRINGS end to end (never parsed
// through a float), e.g. the Create Budget amount cell.
export const MONEY_STRING_REGEX = /^\d+(\.\d+)?$/;
export const phoneRegex = /^\s*([+]977\d{10}|[+]61\d{9,10})\s*$/;
export const HEIC_HEIF_REGEX = /\.(heic|heif)$/i;
export const COMMA_REGEX = /,/g;
/** Global pattern to match underscores (e.g. for replace with space: "valid_task" -> "valid task"). */
export const UNDERSCORE_GLOBAL_PATTERN = /_/g;

export const DATE_FORMATS_REGEX = {
  YYYY_MM_DD: /^\d{4}-\d{2}-\d{2}$/,
} as const;
export const HEX_COLOR_6_DIGIT_REGEX = /^[0-9A-Fa-f]{6}$/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const HTML_TAGS_REGEX = /<\/?[^>]+(>|$)/g;

/** Matches "(code) name" or "(code) name (Archived)" style resource labels. */
export const RESOURCE_LABEL_PATTERN = /^\([^)]+\)\s+.+/;
/** Captures code and name from "(code) name" for parsing. */
export const RESOURCE_LABEL_PREFILL_PATTERN = /^\(([^)]+)\)\s*(.+)$/;
/** Extracts display name from "(code) name" or "(code) name (Archived)". */
export const RESOURCE_LABEL_DISPLAY_PATTERN =
  /^\([^)]+\)\s*(.+?)(?:\s*\(Archived\))?\s*$/;
/** Validates decimal input: optional minus, optional integer, optional decimal with up to 12 decimal places */
export const VALID_DECIMAL_INPUT_REGEX = /^-?(?!$)?(\d*\.?\d{0,12})?$/;

/** Matches a string that is empty or contains only '0' characters (e.g. decimal part with only zeros) */
export const ONLY_ZEROS_OR_EMPTY_REGEX = /^0*$/;

/*
 * Matches all underscores globally in a string
 * */
export const GLOBAL_UNDERSCORE_REGEX = /_/g;

/**
 * Matches the first letter of each word
 * */
export const WORD_INITIAL_REGEX = /\b\w/g;

/** Detects https?:// or www. URLs in running text (not full RFC 3986 validation).
 * https?:\/\/ — http:// or https://
 * |www\. — or starts with www.
 * [^\s<]+ — run of non-whitespace, non-<
 * [^<.,:;"'\]\s] — last char not punctuation that usually ends a sentence/link
 */
export const URL_REGEX = /(?:https?:\/\/|www\.)[^\s<]+[^<.,:;"'\]\s]/gi;
